import React, { useState } from 'react';
import '../styles/AppointmentTypeSelector.css';
import CheckboxOption from '../components/shared/CheckboxOption';
import { useApp } from '../context/appContext';
import { EYE_TEST_ID, CONTACT_LENSES_ID } from '../utils/constants';
import { fbApiUrl } from "./shared/facebooktrack_config";  


const AppointmentTypeSelector = () => {

  const { form, setForm } = useApp()
  const [selectedOption, setSelectedOption] = useState(form?.testId || null);

  const options = [
    { id: EYE_TEST_ID, label: 'Eye Test', icon: require('../assets/icons/eye-test.png') },
    { id: CONTACT_LENSES_ID, label: 'Contact Lenses', icon: require('../assets/icons/contact-lenses.png') }
  ];


  const handleOptionChange = async (optionId, optionLabel) => {


    if (!fbApiUrl) {
      console.error("Error: fbApiUrl is not defined!");
    } 
    else {
      try{

        let optionLabel_set = 'Appointment Type Eye Test';

        if(optionLabel === 'Contact Lenses') {
          optionLabel_set = 'Appointment Type Contact Lenses';
        }
        
        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const clientIp = ipData.ip; // Extracted IP Address

        // Get User Agent
        const userAgent = navigator.userAgent;

        const data = {
          data: [
            {
              event_name: optionLabel_set,
              event_time: Math.floor(Date.now() / 1000),
              user_data: {
                client_ip_address: clientIp,
                client_user_agent: userAgent,
              },
              action_source: "website",
            },
          ],
          test_event_code: "TEST58912",
        };
      
        const response = await fetch(fbApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
    
        const result = await response.json();
      }
      catch (error) {
        console.error("Error sending data to Facebook API:", error);
      }
    }
    
    setSelectedOption(optionId)
    setForm({ ...form, testId: optionId })
  }

  return (
    <div className="appointment-type-selector">
      <div className="appointment-type-container">
        <h3>Select your Appointment Type <span style={{ color: 'red' }}>*</span></h3>
        <div className="appointment-type-options">
        {options.map(option => (
          <CheckboxOption
            key={option.id}
            icon={option.icon}
            label={option.label}
            isSelected={selectedOption === option.id}
            onChange={() => handleOptionChange(option.id, option.label)}
          />
        ))}
        </div>
      </div>
    </div>
  );
};

export default AppointmentTypeSelector;
